import { Link, Text } from '@chakra-ui/react';
import { getUTMParametersFromUrl } from 'api/branch/storage';
import useGenerateBranchLink from 'hooks/useGenerateBranchLink';
import {
  APP_DEFAULT_DEEPLINK,
  getFallbackDownloadLink
} from 'lib/branch/helpers';
import React, { useEffect, useState } from 'react';

const deepLink = APP_DEFAULT_DEEPLINK;
const fallbackDownloadLink = `${getFallbackDownloadLink({
  deepLink
})}&utm_source=download_app`;

const GetAppFooterLink = () => {
  const { create: createStoreLink } = useGenerateBranchLink();
  const [downloadLink, setDownloadLink] = useState(fallbackDownloadLink);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const utmDetails = getUTMParametersFromUrl();

    createStoreLink({
      deepLink,
      webLink: 'https://web.insighttimer.com/download-app',
      campaign: utmDetails?.utm_campaign ?? 'web-share',
      utmContent: utmDetails.utm_content,
      utmMedium: utmDetails.utm_medium,
      utmTerm: utmDetails.utm_term,
      title: document.title,
      additionalBranchData: { $og_title: document.title },
      channel: 'download_app'
    }).then(result => {
      if (result?.link) setDownloadLink(result.link);
      setIsReady(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Link
      href={downloadLink}
      aria-disabled={!isReady}
      tabIndex={isReady ? undefined : -1}
      pointerEvents={isReady ? 'auto' : 'none'}
      _hover={{ textDecor: 'none' }}
    >
      <Text
        fontSize="sm"
        lineHeight="1.5"
        fontWeight="semibold"
        color="primary.white"
      >
        Get the App
      </Text>
    </Link>
  );
};

export default GetAppFooterLink;
